import { Module } from "wrapper6";

var $ = jQuery;

export default class Lexicon extends Module {

	ready(app) {

        this.LOADER = $('#loader-overlay');

        this.SEARCH_INPUT = $('#lexicon-search');
        this.SEARCH_BUTTON = $('.mtt-lexicon .search-button');
        this.LETTER_BUTTON = $('.mtt-lexicon .mtt-lexicon__letter');
        this.LETTER_MOBILE = $('#alphabet-mobile');

        this.DESTINATION = $('.mtt-lexicon__loop-wrapper');
        this.PAGINATION = '.mtt-lexicon #lexicon-pagination ul li a';
        this.PAGINATION_DEST = $('#lexicon-pagination');

        // data
        this.search_value = '';
        this.page_number = 0;
        this.letter = '';

        this.addEventListeners();

    }

    addEventListeners() {
        this.search();
        this.playSound();
    }

    search() {
        this.SEARCH_BUTTON.on('click', () => {
            $('.mtt-lexicon__letter.active').removeClass('active');
            this.search_value = this.SEARCH_INPUT.val();
            this.page_number = 0;
            this.letter = '';

            this.getResults();
        });

        this.LETTER_BUTTON.on('click', (e) => {                                  

            if ($(e.target).hasClass('active')) {
                $(e.target).removeClass('active');
                this.search_value = '';
                this.letter = '';
                this.page_number = 0; 
                this.is_active = false;  
            } else {
                $('.mtt-lexicon__letter.active').removeClass('active');   
                $(e.target).addClass('active');
                this.search_value = '';
                this.letter = $(e.target).html();
                this.page_number = 0;   
            }

            this.getResults();
        });

        this.LETTER_MOBILE.on('change', (e) => {
            for (let i = 0; i < this.LETTER_BUTTON.length; i++) {
                const BUTTON = $(this.LETTER_BUTTON[i]);
                const BUTTON_VAL = $.trim(BUTTON.html());
                
                if (BUTTON_VAL == $(e.target).val()) {
                    $('.mtt-lexicon__letter.active').removeClass('active'); 
                    BUTTON.addClass('active');
                }

                if ($(e.target).val() == '') {
                    $('.mtt-lexicon__letter.active').removeClass('active');
                }
                
            }

            this.letter = $(e.target).val();
            this.search_value = '';
            this.page_number = 0;  

            this.getResults();
        });

        // Click on pagination
		$(document).on('click', this.PAGINATION, (e) => {
                                    
			// Prevent default link behavior
			e.preventDefault();

			// Update page number
            this.page_number = $(e.target).attr('data-page');            

			// Run ajax request
			this.getResults();

		});

        $(document).on('keypress',(e) => {
            if(e.which == 13) {
                if (this.SEARCH_INPUT.is(':focus')) {
                    $('.mtt-lexicon__letter.active').removeClass('active');
                    this.search_value = this.SEARCH_INPUT.val();
                    this.page_number = 0;
                    this.letter = '';
        
                    this.getResults();
                }
            }
        });
    }

    getResults() {
        	// Show loader
            this.LOADER.addClass('show');	
            
            // Animate to top
            $('html, body').animate({ 
                scrollTop: $('.mtt-lexicon').offset().top - 50
            }, 500);

			// Set ajax data
			let data = {
				'action': 'filter_lexicon',
                's': this.search_value,
                'letter': this.letter,
				'page_number': this.page_number,
				'url': window.location.href,
            };
            
			// Ajax call
			jQuery.post(main_theme_objects.ajax_url, data, (response) => {	                            

				if (response != 0) {                  
                                    
					// Post response
                    if (response.markup !== "") {
                        this.DESTINATION.html(response.markup);                    
                        this.DESTINATION.append('<div class="word-card-filler"> </div>');
                        this.DESTINATION.append('<div class="word-card-filler"> </div>');
                    } else {
                        this.DESTINATION.html('<p class="no-posts">Der er desværre ingen indlæg der opnår disse kriterier</p>');
                    }

					// Pagination response
                    this.PAGINATION_DEST.html(response.pagination);
                    
					// Hide loader
					this.LOADER.removeClass('show');

				}
			});
    }

    playSound() {
        const SOUND_BTN = document.querySelector('.mtt-lexicon-cover__pronunciation .sound');

        if (SOUND_BTN) {
            SOUND_BTN.addEventListener('click', () => {
                const AUDIO_FILE = SOUND_BTN.getAttribute('data-sound');
                const AUDIO = new Audio(AUDIO_FILE);

                AUDIO.play();
            });
        }
    }
}